import { AxiosPromise } from 'axios';
import * as ThumbnailsProvider from '../../providers/thumbnails/thumbnailsProvider';

const assetsApiInstance = new ThumbnailsProvider.AssetsApi();
const bundlesApiInstance = new ThumbnailsProvider.BundlesApi();
const avatarApiInstance = new ThumbnailsProvider.AvatarApi();
const groupEmblemApiInstance = new ThumbnailsProvider.GroupEmblemApi();
const badgesApiInstance = new ThumbnailsProvider.BadgesApi();

const getAssets = (
  assetIds: Array<number>,
  returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated',
  size?: '150x150' | '420x420',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return assetsApiInstance.v1AssetsGet(assetIds, returnPolicy, size, format);
};
const getAvatars = (
  userIds: Array<number>,
  size?: '100x100' | '352x352' | '720x720',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return avatarApiInstance.v1UsersAvatarGet(userIds, size, format);
};

const getAvatarHeadshots = (
  userIds: Array<number>,
  size?: '48x48' | '60x60' | '150x150',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return avatarApiInstance.v1UsersAvatarHeadshotGet(userIds, size, format);
};

const getBundles = (
  bundleIds: Array<number>,
  size?: '150x150' | '420x420',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return bundlesApiInstance.v1BundlesThumbnailsGet(bundleIds, size, format);
};

const getGroupIcons = (
  groupIds: Array<number>,
  size?: '150x150' | '420x420',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return groupEmblemApiInstance.v1GroupsIconsGet(groupIds, size, format);
};

const getBadgeIcons = (
  badgeIds: Array<number>,
  size?: '150x150',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return badgesApiInstance.v1BadgesIconsGet(badgeIds, size, format);
};

export default {
  getAssets,
  getAvatars,
  getAvatarHeadshots,
  getGroupIcons,
  getBadgeIcons,
  getBundles
};
